import IframeCommuncationService from './iframeCommunicationService'

const widgetCommuncationService = new IframeCommuncationService()

export default widgetCommuncationService
